import { render } from "./HowToSolve.vue?vue&type=template&id=11c57f06"
import script from "./HowToSolve.vue?vue&type=script&lang=js"
export * from "./HowToSolve.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__